<div *ngIf="order" class="order">
  <div>Bestellnummer: {{ order.id }}</div>
  <div *ngIf="order.created_at">
    Bestelldatum: {{ order.created_at | date: 'dd.MM.yyyy HH:mm' }}
  </div>
  <div class="address" *ngIf="order.billing_address">
    <h4>Rechnungsadresse</h4>
    <div>
      {{ order.billing_address.name }}<br />{{ order.billing_address.street }}
      {{ order.billing_address.street_2 }}  {{ order.billing_address.street_number }}<br />{{ order.billing_address.zip }}
      {{ order.billing_address.city }}<br />{{ order.billing_address.country }}
    </div>
  </div>
  <div class="address" *ngIf="order.shipping_address">
    <h4>Lieferadresse</h4>
    <div>
      {{ order.shipping_address.name }}<br />{{
        order.shipping_address.street
      }}
      {{ order.shipping_address.street_2 }} {{ order.shipping_address.street_number }}<br />{{
        order.shipping_address.zip
      }}
      {{ order.shipping_address.city }}<br />{{
        order.shipping_address.country
      }}
    </div>
  </div>
  <div *ngIf="order.lineItems" class="lines">
    <table>
      <thead>
        <th>Name</th>
        <th>Menge</th>
        <th>Preis</th>
        <th>Zeilensumme</th>
      </thead>
      <ng-container *ngIf="orderDTO && orderDTO.getAllLines()">
        <tr *ngFor="let line of orderDTO.getAllLines()" class="line">
          <td>{{ line.name }}</td>
          <td>{{ line.quantity }}</td>
          <td>{{ line.price.getAmountGross()  | number: '1.2-2' }} €</td>
          <td>
            {{ line.price.getAmountGross()*(line.quantity) | number: '1.2-2' }} €
          </td>
        </tr>
      </ng-container>
      <ng-template #lineItemElse >
      <tr *ngFor="let line of order.lineItems" class="line">
        <td>{{ line.name }}</td>
        <td>{{ line.quantity }}</td>
        <td>{{ line.price.getAmountGross()  | number: '1.2-2' }} €</td>
        <td>
          {{ line.price.getTotalAmountGross(line.quantity) | number: '1.2-2' }} €
        </td>
      </tr>
      </ng-template>
    </table>
  </div>
  <div class="total" *ngIf="order.totalPrice">
    <div>
    <span>Brutto</span><span>{{ order.totalPrice.getAmountGross() | number: '1.2-2' }} €</span>
    <span>Netto</span><span> {{ order.totalPrice.getAmountNet() | number: '1.2-2' }} €</span>
      <ng-container *ngFor="let tax of order.totalPrice.taxes">
        <span>{{ tax.taxgroup.label }}</span> <span>{{ tax.getAmount() | number: '1.2-2' }} €</span>
      </ng-container>
    </div>
  </div>
</div>

<pre class="hidden">{{ order | json }}</pre>
